export var getDecodedCookie = key => {
  var encodedCookie = document.cookie.split('; ').find(row => row.startsWith(key)).split('=')[1];
  var decodedCookie = decodeURIComponent(encodedCookie);
  var value = JSON.parse(decodedCookie);
  return value;
};